import { combineReducers } from 'redux';
import { chartingReducer } from '../../charting/redux/reducers';

export const rootReducer = combineReducers({
   charts: chartingReducer,
});

export type RootStateT = ReturnType<typeof rootReducer>;
